// extracted by mini-css-extract-plugin
export var dropdown = "dropdown-module--dropdown--35bb0";
export var opened = "dropdown-module--opened--a2dc8";
export var triangle = "dropdown-module--triangle--e37f9";